import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const CFG = {
  "job-studio": { url: "/reports/job-funnel", params: {}, title: "Job pipeline · this month" },
  "job-mine": { url: "/reports/job-funnel", params: { mine: true }, title: "My job pipeline · this month" },
  b2b: { url: "/reports/b2b-funnel", params: {}, title: "B2B product pipeline" },
};

const COLORS = [
  "#3F0A72", "#6d28d9", "#9333ea", "#c026d3", "#db2777", "#e11d48",
  "#f43f5e", "#fb7185", "#0ea5e9", "#0284c7", "#0369a1", "#075985", "#0c4a6e",
];

export const PipelineFunnel = ({ variant = "job-studio" }) => {
  const cfg = CFG[variant];
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(cfg.url, { params: cfg.params }).then(({ data }) => setData(data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant]);

  const stages = data?.stages || [];
  const max = stages.length ? Math.max(...stages.map((s) => s.count), 1) : 1;

  return (
    <Card className="border-brand-line shadow-none" data-testid={`funnel-${variant}`}>
      <CardHeader>
        <CardTitle className="text-lg">{cfg.title}</CardTitle>
      </CardHeader>
      <CardContent>
        {stages.length === 0 ? (
          <p className="py-8 text-center text-sm text-slate-500">No pipeline data yet.</p>
        ) : (
          <div className="space-y-2.5">
            {stages.map((s, i) => {
              const w = Math.max(9, Math.round((s.count / max) * 100));
              return (
                <div key={s.stage} data-testid={`funnel-stage-${s.stage}`}>
                  <div className="mb-1 flex items-center justify-between text-xs">
                    <span className="font-medium text-brand-ink">{s.stage}</span>
                    <span className="text-slate-500">
                      {s.count}
                      {i > 0 && <span className="ml-1 text-slate-400">· {s.step_conversion}% ↷</span>}
                    </span>
                  </div>
                  <div className="h-7 w-full rounded bg-slate-100">
                    <div
                      className="flex h-7 items-center rounded px-2 text-xs font-semibold text-white"
                      style={{ width: `${w}%`, backgroundColor: COLORS[i % COLORS.length], minWidth: "2.5rem" }}
                    >
                      {s.count}
                    </div>
                  </div>
                </div>
              );
            })}
            <p className="pt-1 text-xs text-slate-400">Total entered: {data.total}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
